import { render, staticRenderFns } from "./PurchaseRequisitionTable.vue?vue&type=template&id=47df07e2&"
import script from "./PurchaseRequisitionTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequisitionTable.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRequisitionTable.vue?vue&type=style&index=0&id=47df07e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports